<div class="booking-container">
  <router-outlet></router-outlet>
</div>

